import React from "react";
import Select from "react-select";
import _ from "lodash";
import classNames from "classnames";
import "./index.css";
import IconStoreModal from "../Polls/components/IconStoreModal";
import { LayerTypes } from "../../Constants/brand";
const icon_pending_img = require("../../assets/media/icons/pending.png");

class ChatbotMakerForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chatbot: props.initial || {
        name: "",
        icon: null,
        welcomeText: "",
        toc: undefined,
        tocText: "",
        communicationLayers: [{ type: "", statement: "" }],
      },
    };
    this.props.onUpdateStatus && this.props.onUpdateStatus(this.state.chatbot);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.initial !== this.props.initial) {
      this.setState({ chatbot: this.props.initial }, () => {
        this.props.onUpdateStatus &&
          this.props.onUpdateStatus(this.state.chatbot);
      });
    }
  }

  handleInputChange = (event) => {
    const { chatbot } = this.state;
    const { name, value } = event.target;

    const newChatbot = _.cloneDeep(chatbot);
    newChatbot[name] = value;
    this.setState({ chatbot: newChatbot }, () => {
      this.props.onUpdateStatus &&
        this.props.onUpdateStatus(this.state.chatbot);
    });
  };

  handleLayerChange = (index, key, value) => {
    const { chatbot } = this.state;
    const newChatbot = _.cloneDeep(chatbot);
    newChatbot["communicationLayers"][index][key] = value;
    this.setState({ chatbot: newChatbot }, () => {
      this.props.onUpdateStatus &&
        this.props.onUpdateStatus(this.state.chatbot);
    });
  };

  handleAnswerChange = (index, answer_index, value) => {
    const { chatbot } = this.state;
    const newChatbot = _.cloneDeep(chatbot);
    newChatbot["communicationLayers"][index].answers[answer_index] = value;
    this.setState({ chatbot: newChatbot }, () => {
      this.props.onUpdateStatus &&
        this.props.onUpdateStatus(this.state.chatbot);
    });
  };

  addNewCommunicationLayer = () => {
    const { chatbot } = this.state;
    const newChatbot = _.cloneDeep(chatbot);
    newChatbot["communicationLayers"].push({ type: "", statement: "" });
    this.setState({ chatbot: newChatbot }, () => {
      this.props.onUpdateStatus &&
        this.props.onUpdateStatus(this.state.chatbot);
    });
  };

  addAnswer = (index) => {
    const { chatbot } = this.state;
    let newChatbot = _.cloneDeep(chatbot);
    if (!newChatbot["communicationLayers"][index].answers)
      newChatbot["communicationLayers"][index].answers = [""];
    else newChatbot["communicationLayers"][index].answers.push("");
    this.setState({ chatbot: newChatbot }, () => {
      this.props.onUpdateStatus &&
        this.props.onUpdateStatus(this.state.chatbot);
    });
  };
  removeAnswer = (index, answer_index) => {
    const { chatbot } = this.state;
    let newChatbot = _.cloneDeep(chatbot);
    newChatbot["communicationLayers"][index].answers.splice(answer_index, 1);
    this.setState({ chatbot: newChatbot }, () => {
      this.props.onUpdateStatus &&
        this.props.onUpdateStatus(this.state.chatbot);
    });
  };
  selectImage = (url) => {
    const { chatbot } = this.state;

    const newChatbot = _.cloneDeep(chatbot);
    newChatbot["icon"] = url;
    this.setState({ chatbot: newChatbot }, () => {
      this.props.onUpdateStatus &&
        this.props.onUpdateStatus(this.state.chatbot);
    });
  };

  publishChatbot = () => {
    const { chatbot } = this.state;
    if (
      !chatbot.name ||
      !chatbot.icon ||
      !chatbot.welcomeText ||
      chatbot.toc === undefined ||
      (chatbot.toc && !chatbot.tocText)
    ) {
      alert("Please fill empty fields");
      return;
    }
    let flag = chatbot.communicationLayers.some((obj) => {
      if (obj.type === "Statement" || obj.type === "Question") {
        return !obj.type || !obj.statement;
      } else if (obj.type === "Polls") {
        if (!obj.answers) return true;
        let empties = obj.answers.filter((answer) => !answer);
        return empties.length || obj.answers.length < 2;
      } else if (!obj.type) return true;
    });
    if (flag) {
      alert("Please fill empty fields");
      return;
    }
    this.props.publishChatbot(this.state.chatbot);

    // Reset chatbot state
    this.setState(
      {
        chatbot: {
          name: "",
          icon: null,
          welcomeText: "",
          toc: undefined,
          tocText: "",
          communicationLayers: [{ type: "", statement: "" }],
        },
      },
      () => {
        this.props.onUpdateStatus &&
          this.props.onUpdateStatus(this.state.chatbot);
      }
    );
  };

  render() {
    const { chatbot } = this.state;
    return (
      <div style={{ textAlign: "left", width: "100%" }}>
        <h4 className="section-title">Chatbot name</h4>
        <input
          name="name"
          className="form-control form-control-md form-control-alt"
          placeholder="Type name"
          value={chatbot.name}
          onChange={this.handleInputChange}
        />
        {chatbot.name && (
          <React.Fragment>
            <h4 className="section-title">Chatbot icon</h4>
            <div className="icon-container">
              <button
                type="button"
                className="btn btn-warning warning-button bg-white"
                data-toggle="modal"
                data-target="#choose_icon"
              >
                Choose Icon
              </button>
              <img
                src={chatbot.icon ? chatbot.icon : icon_pending_img}
                width="40"
                alt="icon"
                style={{
                  marginLeft: 10,
                  marginBottom: 0,
                }}
              />
            </div>
          </React.Fragment>
        )}
        {chatbot.name && chatbot.icon && (
          <React.Fragment>
            <h4 className="section-title">Chatbot welcome message</h4>
            <textarea
              name="welcomeText"
              className="form-control form-control-md form-control-alt"
              placeholder="Welcome message"
              value={chatbot.welcomeText}
              onChange={this.handleInputChange}
            />
          </React.Fragment>
        )}
        {chatbot.name && chatbot.icon && chatbot.welcomeText && (
          <React.Fragment>
            <h4 className="section-title">Terms & Conditions</h4>
            <label>
              <strong>Yes</strong>&nbsp;or&nbsp;<strong>No</strong>
            </label>
            <div className="check-box-container">
              <div
                className={classNames("check-box", {
                  checked: chatbot.toc === true,
                })}
                onClick={() => {
                  this.handleInputChange({
                    target: { name: "toc", value: true },
                  });
                }}
              ></div>
              <div
                className={classNames("check-box", {
                  checked: chatbot.toc === false,
                })}
                onClick={() => {
                  this.handleInputChange({
                    target: { name: "toc", value: false },
                  });
                }}
                style={{
                  marginLeft: "20px",
                }}
              ></div>
            </div>
            {chatbot.toc && (
              <textarea
                name="tocText"
                className="form-control form-control-md form-control-alt"
                placeholder="Terms & Conditions"
                value={chatbot.tocText}
                onChange={this.handleInputChange}
              />
            )}
          </React.Fragment>
        )}
        {chatbot.name &&
          chatbot.icon &&
          chatbot.welcomeText &&
          chatbot.toc !== undefined && (
            <React.Fragment>
              {chatbot.communicationLayers.map((layer, index) => (
                <React.Fragment>
                  <div className="section-title">
                    <h4>Add Communication Layer</h4>
                    <p>{index + 1}</p>
                  </div>
                  <div className="input-container">
                    <Select
                      value={{
                        label: chatbot.communicationLayers[index].type,
                        value: chatbot.communicationLayers[index].type,
                      }}
                      onChange={(value) =>
                        this.handleLayerChange(index, "type", value.value)
                      }
                      options={LayerTypes}
                    />
                  </div>
                  {["Statement", "Question", "Statement agreeableness"].find(
                    (c) => c === chatbot.communicationLayers[index].type
                  ) && (
                    <React.Fragment>
                      <div className="section-title">
                        <h4 className="section-title">
                          {chatbot.communicationLayers[index].type}
                        </h4>
                        <p>{index + 1}</p>
                      </div>
                      <input
                        name="statement"
                        className="form-control form-control-md form-control-alt mb-4"
                        value={chatbot.communicationLayers[index].statement}
                        onChange={({ target }) =>
                          this.handleLayerChange(
                            index,
                            "statement",
                            target.value
                          )
                        }
                        autoComplete="off"
                      />
                    </React.Fragment>
                  )}
                  {chatbot.communicationLayers[index].type === "Polls" && (
                    <React.Fragment>
                      <div className="section-title">
                        <h4 className="section-title">
                          {chatbot.communicationLayers[index].type}
                        </h4>
                        <p>{index + 1}</p>
                      </div>
                      <input
                        name="statement"
                        placeholder="Polls Question"
                        className="form-control form-control-md form-control-alt mb-2"
                        value={chatbot.communicationLayers[index].statement}
                        onChange={({ target }) =>
                          this.handleLayerChange(
                            index,
                            "statement",
                            target.value
                          )
                        }
                        autoComplete="off"
                      />
                      {chatbot.communicationLayers[index].answers &&
                        chatbot.communicationLayers[index].answers.map(
                          (answer, answer_index) => (
                            <div className="polls-answer">
                              <input
                                placeholder="Answer"
                                className="form-control form-control-md form-control-alt mt-2 mb-2"
                                value={
                                  chatbot.communicationLayers[index].answers
                                    ? chatbot.communicationLayers[index]
                                        .answers[answer_index]
                                    : ""
                                }
                                onChange={({ target }) =>
                                  this.handleAnswerChange(
                                    index,
                                    answer_index,
                                    target.value
                                  )
                                }
                                autoComplete="off"
                              />
                              <button
                                onClick={() =>
                                  this.removeAnswer(index, answer_index)
                                }
                              >
                                <i class="fas fa-trash-alt"></i>
                              </button>
                            </div>
                          )
                        )}
                      <button
                        className={`btn btn-orange mb-3`}
                        type="button"
                        onClick={() => this.addAnswer(index)}
                      >
                        Add new answer
                      </button>
                    </React.Fragment>
                  )}
                </React.Fragment>
              ))}
            </React.Fragment>
          )}
        <IconStoreModal selectImage={this.selectImage} />
      </div>
    );
  }
}
export default ChatbotMakerForm;



// WEBPACK FOOTER //
// ./src/screens/ChatbotMaker/ChatbotMakerForm.js